import { Component, OnInit, Input, Output, EventEmitter, ViewChild, TemplateRef, Injector, Optional, ChangeDetectorRef, Inject, LOCALE_ID } from '@angular/core';
import { TreeTableComponent } from '@farris/ui-treetable';
import { Observable, of } from 'rxjs';
import { LookupGridComponent, ServerSideToken } from '@farris/ui-lookup';
import { HttpService } from '@ecp-caf/caf-common';
import { switchMap } from 'rxjs/operators';
import { LookupDataService } from '@farris/lookup-config';
import { MessagerService } from '@farris/ui-messager';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WfBizprocessLookupComponent } from '@gsp-wf/wf-bizprocess-lookup';

@Component({
  selector: 'app-save-as-edit',
  templateUrl: './save-as-edit.component.html',
  styleUrls: ['./save-as-edit.component.scss'],
  providers: [
    { provide: ServerSideToken, useClass: LookupDataService },
     WfLocalePipe,
  ]
})
export class SaveAsEditComponent implements OnInit {

  @ViewChild('buttonRef') btnRef: TemplateRef<any>;

  @Input()
  procName: string;
  @Input()
  procKey: string;

  @ViewChild('lookup') public lookUp: LookupGridComponent;
  @ViewChild("flowFormHelp") flowFormHelp: WfBizprocessLookupComponent;

  @Output() submit = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<any>();
  groupIcon2 = '<i class="f-icon f-icon-lookup"></i>';

  accessLevel = 'public';
  organization;
  organizationName;

  isAdministratorConfig = false;
  enableAdminOrgAut = false;

  administrator: any;
  dataUri = '/api/runtime/sys/v1.0/sysOrgs';

  loadType = 'layerload';

  disabled = false;

  // private _organizations: any[];
  // set organizations(data: any[]) {
  //   this._organizations = data;
  //   if (this._organizations && this._organizations.length > 0) {
  //     this.items = this.makeTreeByParent(this._organizations, 'parentId', 'id');
  //   } else {
  //     this.items = new Array();
  //   }
  // }
  // get organizations() {
  //   return this._organizations;
  // }
  items = new Array();

  accessLevelCollection = [
    { value: 'public', text: this.localePipe.transform('component.saveAsEdit.public') },
    { value: 'private', text: this.localePipe.transform('component.saveAsEdit.private') }
  ];

  columns = [
    { title: this.localePipe.transform('component.saveAsEdit.code'), field: 'code', width: '100', searchField: 'code' },
    { title: this.localePipe.transform('component.saveAsEdit.name'), field: 'name', width: '100', searchField: 'name' },
  ];

  // 单选组绑定
  radioGroupValue = "SelfBill";
  // 单选组数据
  radioGroupDatas = [
    { value: 'SelfBill', name: this.localePipe.transform('component.saveAsEdit.thisDocument') },
    { value: 'OtherBill', name: this.localePipe.transform('component.saveAsEdit.otherDocument') }
  ];
  //选择的流程分类
  bizDef;

  //展示的流程分类名字
  bizDefName;

  filterBizCat = {
    businessObjectId: ''
  };
  

  constructor(
    private injector: Injector,
    private http: HttpService,
    private message: MessagerService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
  }

  commonRadioValueChange(data: any) {
    this.bizDef = null;
  }

  selectBizdefKey(data: any) {
    setTimeout(() => {
      this.flowFormHelp.showHelp();
    }, 0);
  }

  clearBizdefKey(index: any) {
    this.bizDef = null;
    this.bizDefName = '';
  }

  flowFormConfirm(data: any) {
    if (data) {
      this.bizDef = data;
      this.bizDefName = data.name;
    }
  }

  clearFlowForm(data:any) {
    this.bizDef = null;
    this.bizDefName = '';
  }


  saveAsOK() {
    this.disabled = true;
    if (this.validator()) {
      this.submit.next({
        procName: this.procName,
        bizDef: this.radioGroupValue != 'SelfBill' ? this.bizDef : undefined,
        accessLevel: this.accessLevel,
        organization: this.organization,
        organizationName: this.organizationName
      });
    }
  }
  saveAsCancel() {
    this.cancel.emit();
  }

  validator() {
    if (!this.procName) {
      this.message.warning(this.localePipe.transform('component.saveAsEdit.nameNotEmpty'));
      this.disabled = false;
      return false;
    }
    if(this.radioGroupValue != 'SelfBill' && (!this.bizDef || !this.bizDef.id)) {
      this.message.warning(this.localePipe.transform('component.saveAsEdit.entryFormEmpty'));
      this.disabled = false;
      return false;
    }
    if (!this.organization) {
      this.message.warning(this.localePipe.transform('component.saveAsEdit.organizationNotEmpty'));
      this.disabled = false;
      return false;
    }
    return true;
  }

  checkExpressionsByPayload(bizDefKey: string, schema: any): Observable<any> {
    const checkExpressionsPayload = {
      bizDefKey: bizDefKey,
      schema: schema
    };
    const url = `/api/runtime/wf/v1.0/dtProcDefs/checkExpressionsByPayload`;
    return this.http.post(url, checkExpressionsPayload);
  }

  search(data: any) {
    const tt = this.lookUp.componentRef.instance as TreeTableComponent;
    tt.searchHandle.search(data.field, data.value, 'client');
  }

  dictPicking = (data: any) => {
    this.lookUp.http = {
      getData: (uri, params) => {
        console.log(params);
        const searchValue = JSON.parse(params.searchValue);
        const parent = searchValue.parentId;
        let param;

        if (this.lookUp._searchState && this.lookUp._searchState.field && this.lookUp._searchState.value) {
          if (this.lookUp._searchState.field === '*') {
            param = { codeOrName: this.lookUp._searchState.value };
          } else if (this.lookUp._searchState.field === 'name') {
            param = { name: this.lookUp._searchState.value };
          } else {
            param = { code: this.lookUp._searchState.value };
          }
        }
        let filter;
        if (this.isAdministratorConfig) {
          filter = this.administrator.administratorAuthorities.map(a => ({
            id: a.organization, rule: a.includeSubordinate ? 'SelectedAndChild' : 'Selected'
          }));
        }
        return this.getSysOrgs(parent, param, filter).pipe(
          switchMap((re: any) => {
            console.log(re);
            return of({
              columns: this.columns,
              displayInfo: { idField: 'id', valueField: 'id', textField: 'name' },
              displayType: 'TreeList',
              idField: 'id',
              valueField: 'id',
              textField: 'name',
              searchFields: [
                { label: 'code', value: 'code' }, { label: 'name', value: 'name' }
              ],
              title: this.localePipe.transform('component.saveAsEdit.organization'),
              total: 0,
              treeInfo: {
                dataField: 'treeinfo',
                isDetailField: 'isDetail',
                layerField: 'layer',
                layerType: 'parentId',
                loadDataType: 'async',
                onlySelectLeaf: false,
                parentField: 'parentElement',
                pathField: 'path',
                treeDataIsInit: true
              },
              items: this.orgTreeData(re, param)
            } as any);
          })
        );
      }
    };
    return of(true);
  }

  dictPicked = (data: any) => {
    this.organizationName = data.name;
    this.organization = data.id;
    return of(true);
  }

  selectedDataHandler(data) {
    this.organization = data.id;
    this.organizationName = data.name;
  }

  private orgTreeData(orgs: any[], searchValue: any) {
    const result = new Array();
    const treeData = new Array();
    for (const org of orgs) {
      const entity: any = {};
      entity.data = org;
      entity.children = [];
      entity.id = org.id;
      entity.leaf = org.isDetail;
      entity.selectable = org.farris_selectable;

      treeData.push(entity);
    }

    const obj = {}; // 使用对象重新存储数据
    const len = treeData.length;
    for (let i = 0; i < len; i++) {
      const d = treeData[i];
      obj[treeData[i].id] = treeData[i];
    }
    // 遍历数据
    for (let j = 0; j < len; j++) {
      const data = treeData[j];

      const parentData = obj[data.data.parentId];

      if (parentData) {
        if (!parentData.children) {
          parentData.children = new Array();
        }
        parentData.children.push(data);
      } else {
        result.push(data);
      }
    }
    // 过滤的情况下，不包含下级的节点设置为叶子节点
    if (searchValue) {
      this.treeIterator(result);
    }
    return result;
  }

  private treeIterator(treeData: any[]) {
    if (treeData && treeData.length > 0) {
      for (const d of treeData) {
        if (d.children && d.children.length > 0) {
          this.treeIterator(d.children);
        } else {
          d.leaf = true;
        }
      }
    }
  }

  private findChild(item, orgs) {
    const childList = orgs.filter(childitem => {
      if (childitem.parentId === item.id) {
        return true;
      }
    });
    if (childList && childList.length > 0) {
      childList.forEach(child => {
        const childEntity: any = {};
        childEntity.data = child;
        childEntity.children = [];
        childEntity.id = child.id;
        childEntity.leaf = child.isDetail;
        childEntity.selectable = child.farris_selectable;
        item.children.push(childEntity);
        this.findChild(childEntity, orgs);
      });
    }
  }

  /** 按照parent码构造树 */
  private makeTreeByParent(datas: any[], parentField: string, keyField: string): any[] {
    // 上級爲空，或者沒有上級的
    const pathLayerOnes = datas.filter(x => {
      if (!x[parentField]) {
        return true;
      }
      const p = datas.find(parent => parent[keyField] === x[parentField]);
      if (!p) {
        return true;
      }
    });
    const treedata = [];
    pathLayerOnes.forEach(x => {
      const entity: any = {};
      entity.data = x;
      entity.children = [];
      treedata.push(entity);
      // this.root = x['id'];
    });
    treedata.forEach(item => {
      this.findChildrenByParent(item, datas, parentField, keyField);
    }
    );
    return treedata;
  }

  /** 找到子节点 */
  private findChildrenByParent(parent: any, datas: any[], parentField: string, keyField: string) {
    const childList = datas.filter(childitem => {
      if (childitem[parentField] === parent.data[keyField]) {
        return true;
      }
    });
    if (childList && childList.length > 0) {
      childList.forEach(child => {
        const childEntity: any = {};
        childEntity.data = child;
        childEntity.children = [];
        parent.children.push(childEntity);
        this.findChildrenByParent(childEntity, datas, parentField, keyField);
      });
    }
  }


  private getSysOrgs(parent: string, searchValue: any, filter: any[]): Observable<any> {
    let url = `/api/runtime/sys/v1.0/sysOrgs`;
    let param;
    if (searchValue) {
        param = Object.assign(searchValue, {
            IsSearchTree: true,
            withPermission: true,
            ruleFilter: filter
        });
    } else {
        if (parent) {
            param = Object.assign({}, {
                parentId: parent,
                withPermission: true,
                ruleFilter: filter
            });
        } else {
            param = Object.assign({}, {
                parentId: '',
                layer: 1,
                withPermission: true,
                ruleFilter: filter
            });
        }
    }
    url += `?param=${JSON.stringify(param)}`;

    return this.http.get(url);
}
}
